import { GatsbyBrowser } from 'gatsby';

import { Root, Page } from './src/components/organisms/Provider';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = Root;
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = Page;
